import { DocHome } from '@/Doc-Home';
import { CommonHero } from '@/layout/Common-Hero';
import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';
// import { OurTeam } from '@/Our-Team';
import { Seo } from '@/Seo';
import React from 'react';
import { OurTeam } from '@/Our-Team';

const StyledMeetTheDentists = styled.div``;

const breadCrumbs = [{ name: 'About Us', url: '/about-us/' }];

const MeetTheDentists: React.FC = () => {
    return (
        <React.Fragment>
            <Seo
                title="Our Team | Claremont Family Dentistry | Claremont, NC"
                description="Dr. Michael J. Gordon is the owner and one of two dentists here at Claremont Family Dentistry"
            />
            <StyledMeetTheDentists>
                <CommonHero breadCrumbs={breadCrumbs} title="Our Team">
                    <StaticImage
                        src="../../images/meet-the-dentists/hero-image.jpg"
                        placeholder="none"
                        quality={100}
                        alt="woman smiling"
                    />
                </CommonHero>
                <DocHome />
                <OurTeam />
            </StyledMeetTheDentists>
        </React.Fragment>
    );
};

export default MeetTheDentists;
